import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-threats-notifications',
  templateUrl: './threats-notifications.component.html',
  styleUrls: ['./threats-notifications.component.scss']
})
export class ThreatsNotificationsComponent implements OnInit {

  notifications: any;
  workers: any;

  formGroup = new FormGroup({
    worker_id: new FormControl(''),
    sent_from: new FormControl(''),
    sent_until: new FormControl(''),
  });

  pagination = { page: 1, pageSize: 25, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {
    this.pagination.page = 1;
    this.loadWorkers();
    this.getNotifications();
  }

  loadWorkers(): void {
    this.okService.get('workers', { pagesize: 500, sort: 'name' }).subscribe((data) => {
      this.workers = data.body;
    });
  }

  getNotifications(): void {
    const filter: any = {
      page: this.pagination.page,
      expand: 'worker,threat_zone',
      worker_id: this.formGroup.value.worker_id,
      sent_from: this.formGroup.value.sent_from,
      sent_until: this.formGroup.value.sent_until,
    };

    Object.keys(filter).forEach((key) => {
      if (filter[key] === '' || filter[key] === null) {
        delete filter[key];
      }
    });

    this.okService.get('threat-notifications', filter).subscribe((data) => {
      this.notifications = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;
    });
  }

  updateFilter(): void {
    this.pagination.page = 1;
    this.getNotifications();
  }

  changePage(): void {
    this.getNotifications();
  }

  formatLabel(value: string): string {
    if (!value) {
      return '';
    }
    return value
      .replace(/[_-]+/g, ' ')
      .trim()
      .split(/\s+/)
      .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }

  categoryColor(category: string): string {
    const map: Record<string, string> = {
      weather: '#1e90ff',
      civil_unrest: '#dc3545',
      heat_zone: '#fd7e14',
      hazard: '#6f42c1',
      custom: '#6c757d',
      factal: '#0d9488',
    };
    return map[category] || '#6c757d';
  }

  categoryBadgeStyle(category: string): { [key: string]: string } {
    return { 'background-color': this.categoryColor(category), color: '#fff' };
  }

  alertTypeColor(type: string): string {
    const map: Record<string, string> = {
      in_zone: '#0d6efd',
      proximity: '#fd7e14',
    };
    return map[type] || '#6c757d';
  }

  alertTypeBadgeStyle(type: string): { [key: string]: string } {
    return { 'background-color': this.alertTypeColor(type), color: '#fff' };
  }

  severityColor(severity: string): string {
    const map: Record<string, string> = {
      Extreme: '#8B0000',
      Severe: '#FF4500',
      Moderate: '#FFA500',
      Minor: '#FFD700',
      Unknown: '#808080',
    };
    return map[severity] || '#cccccc';
  }

  severityBadgeStyle(severity: string): { [key: string]: string } {
    return { 'background-color': this.severityColor(severity), color: '#fff' };
  }
}
